import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-review-vehicles',
  templateUrl: './review-vehicles.component.html',
  styleUrls: ['./review-vehicles.component.scss']
})
export class ReviewVehiclesComponent implements OnInit, OnChanges {

  @Input() vehicles = [];
  @Input() reviewVehiclesHeader: string = '';
  @Input() reviewVehiclesMessage: string = '';
  @Input() reviewVehiclesNote: string;
  @Input() okButtonText: string = "OK";

  @Output() closeEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() saveEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  removeSelectedVehicle(vehicleIndex) {
    if (this.vehicles.length > 1) {
      this.vehicles.splice(vehicleIndex, 1);
    }
    console.log("selected vehicles: ", this.vehicles);
  }

  closeReviewVehicles() {
    this.vehicles = [];
    this.closeEmitter.emit();
  }

  reviewVehiclesSubmit() {
    this.saveEmitter.emit(this.vehicles);
  }

}
